let Screen = {

	//Определяем данные по-умолчанию для каждого компонента Vue
	data() {
		return {
			showed: false
		}
	},

	//В момент создания экземпляра компонента
	created() {

		//Если это главный компонент (скрин / экран)
		if (this.$options.screen) {

			//Преобразуем его имя добавляя пробелы для создания событий вида Show Game Enter Dialog из имени GameEnterDialog
			let event_name = (this.$options.name || '').replace(/([A-Z])/g, ' $1').trim();

			//Создаём обработку события которое можно вызвать через Broadcast чтобы показать этот компонент
			Broadcast.on("Show " + event_name, (...params) => {

				//Показываем компонент
				this.show(...params);

			}, "vue-component-" + this._uid + "-" + this.$options.name);

			//Создаём обработку события которое можно вызвать через Broadcast чтобы обновить данные этого компонента
			Broadcast.on("Update " + event_name, (...params) => {

				//Обновляем компонент если он показан
				this.update("Update " + event_name, ...params);

			}, "vue-component-" + this._uid + "-" + this.$options.name);

			//Создаём обработку события которое можно вызвать через Broadcast чтобы скрыть этот компонент
			Broadcast.on("Hide " + event_name, () => {

				//Скрываем текущий компонент
				this.hide();

			}, "vue-component-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен показать этот компонент
			if (this.$options.screen.showOn) {

				//Проходим по всем таким событиям
				this.$options.screen.showOn.forEach((event_name) => {

					//Добавляем обработчик такого события
					Broadcast.on(event_name, () => {

						//Показываем компонент
						this.show();

					}, "vue-component-show-on-" + this._uid + "-" + this.$options.name);

				});

			}

			//Если указаны имена событий вызов которых должен обновить этот компонент
			if (this.$options.screen.updateOn) {

				//Проходим по всем таким событиям
				this.$options.screen.updateOn.forEach((event_name) => {

					//Добавляем обработчик такого события
					Broadcast.on(event_name, (...params) => {

						//Обновляем компонент если он показан
						this.update(event_name, ...params);

					}, "vue-component-update-on-" + this._uid + "-" + this.$options.name);

				});

			}

			//Если указаны имена событий вызов которых должен скрыть этот компонент
			if (this.$options.screen.hideOn) {

				//Проходим по всем таким событиям
				this.$options.screen.hideOn.forEach((event_name) => {

					//Добавляем обработчик такого события
					Broadcast.on(event_name, () => {

						//И скрываем текущий компонент
						this.hide();

					}, "vue-component-hide-on-" + this._uid + "-" + this.$options.name);

				});

			}

			//Обработываем другие события
			if (this.$options.screen.events) {

				//Проходим по всем таким событиям
				_.each(this.$options.screen.events, (event_fn, event_name) => {

					//Добавляем обработчик такого события
					Broadcast.on(event_name, (...args) => {

						event_fn.apply(this, args);

						//Заставляем пересмотреть все данные
						this.$forceUpdate();

					}, "vue-component-event-" + this._uid + "-" + this.$options.name);

				});

			}

			//Если компонент должен обладать свойством 
			this.showed = ("showed" in this.$options.screen) ? this.$options.screen.showed : true;

		}

	},

	mounted() {

		if (this.collectData) this.collectData('mounted');

		this.$forceUpdate();

	},

	destroyed() {

		//Если это главный компонент (скрин / экран)
		if (this.$options.screen) {

			//Преобразуем имя добавляя пробелы для создания событий вида Show Game Enter Dialog из имени GameEnterDialog
			let event_name = (this.$options.name || '').replace(/([A-Z])/g, ' $1').trim();

			//Убираем обработчики главных событий
			Broadcast.off(["Show " + event_name, "Update " + event_name, "Hide " + event_name], "vue-component-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен показать этот компонент
			//Убираем обработчик таких событий
			if (this.$options.screen.showOn) Broadcast.off(this.$options.screen.showOn, "vue-component-show-on-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен обновить этот компонент
			//Убираем обработчик таких событий
			if (this.$options.screen.updateOn) Broadcast.off(this.$options.screen.updateOn, "vue-component-update-on-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен скрыть этот компонент
			//Убираем обработчик таких событий
			if (this.$options.screen.hideOn) Broadcast.off(this.$options.screen.hideOn, "vue-component-hide-on-" + this._uid + "-" + this.$options.name);

			//Если указаны другие события
			//Убираем обработчик таких событий
			if (this.$options.screen.events) Broadcast.off(_.keys(this.$options.screen.events), "vue-component-hide-on-event-" + this._uid + "-" + this.$options.name);

		}

	},

	methods: {

		//Показываем компонент
		show(...params) {

			//Устанавливаем свойство showed которое должно обрабатываться в компоненте показывая и скрывая его
			this.showed = Date.now();

			//Вызываем метод обновляющий данные Vue
			if (this.collectData) this.collectData('show', ...params);

			//Заставляем пересмотреть все данные
			this.$forceUpdate();

		},

		//Скрываем компонент
		hide() {

			this.showed = false;

		},

		//Обновляем компонент если он показан
		update(event_name, ...params) {

			//Обновляем только если компонент показан
			if (!this.showed) return;

			//Вызываем метод обновляющий данные Vue
			if (this.collectData) this.collectData(event_name, ...params);

			//Заставляем пересмотреть все данные
			this.$forceUpdate();

		}

	}

};

export default Screen;
